import Experience from "../../Experience";

export default class Project {
    constructor(data) {
        this.experience = new Experience();
        this.container = document.querySelector('.projects-container');
        this.data = data;

        // IB-themed filler paragraphs — one picked per project based on index
        const ibParagraphs = [
            "The IB curriculum is designed to develop internationally minded people who help to create a better and more peaceful world. With rigorous academic standards, it pushes students to think critically, engage with complex ideas, and connect knowledge across disciplines.",
            "Studying for the IB can feel overwhelming, but the skills you build — analytical thinking, structured writing, time management — carry far beyond the exam hall. These resources are here to make that journey a little less brutal.",
            "Theory of Knowledge asks you to question the very foundations of what you know. It's uncomfortable, occasionally infuriating, and probably the most genuinely useful thing the IB will teach you. Good luck.",
            "The Extended Essay is 4,000 words of pain, but also an opportunity to go deep on something you actually care about. Pick your topic wisely. Start early. Cite everything.",
            "Internal Assessments count for more than students think. They are your chance to demonstrate understanding in a format that isn't just a timed exam. Take them seriously.",
            "The IB Learner Profile asks you to be a communicator, a thinker, a risk-taker, and about six other things simultaneously. You won't be all of them at once. That's fine. Pick two and work outward.",
            "CAS — Creativity, Activity, Service — exists to remind you that education is bigger than exams. It's also a mandatory requirement. Both things can be true.",
            "Predicted grades matter more than they should. Build a relationship with your teachers, show your thinking process, and don't disappear when things get hard.",
        ]

        // Pick a paragraph based on the article uid hash so it's consistent per subject
        const hash = this.data.uid.split('').reduce((a, c) => a + c.charCodeAt(0), 0)
        const paragraph = ibParagraphs[hash % ibParagraphs.length]

        this.template = `
            <div class="projectRow hidden">
                <div class="project-top">
                    <div class="project-cross cross1"></div>
                    <div class="project-cross cross2"></div>
                    <div class="project-cross cross3"></div>
                    <div class="section">
                        <p class="project-infos">${this.data.data.article_title[0].text}</p>
                        <div class="project-line project-top-line"></div>
                    </div>
                    <div class="section">
                        <p class="project-infos">${this.data.data.article_label[0].text}</p>
                        <div class="project-line project-top-line"></div>
                    </div>
                    <div class="section"></div>
                </div>
                <div class="project-pic" style="height: auto; overflow: visible; padding: 30rem 60rem;">
                    <p style="font-family: var(--text); font-size: 22rem; line-height: 1.7; color: var(--white); opacity: 0.75; max-width: 900rem;">
                        ${paragraph}
                    </p>
                </div>
                <div class="project-bottom">
                    <div class="project-cross cross4"></div>
                    <div class="section"></div>
                    <div class="section"></div>
                    <a href="projects/${this.data.uid}" class="section">
                        <div class="project-line project-bottom-line"></div>
                        <p class="project-infos">SEE DETAILS</p>
                    </a>
                </div>
            </div>
        `;

        this.container.insertAdjacentHTML('beforeend', this.template);
        const projectRow = this.container.querySelector('.projectRow:last-child');
        this.observe(projectRow);
    }

    observe(element) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = 1;
                    obs.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2 });
        observer.observe(element);
    }
}
